import {
  GET_SELECTED_DMP_LEAGUE_LOADING,
  GET_SELECTED_DMP_LEAGUE_SUCCESS,
  GET_SELECTED_DMP_LEAGUE_ID,
  GET_SELECTED_DMP_LEAGUE_ERROR,
  CLEAR_SELECTED_DMP_LEAGUE,
  CLEAR_SELECTED_DMP_LEAGUE_ID,
} from "../../../constant/actionTypes";

const initialState = { loading: false, data: {}, id: null };

const getSelectedDMPLeagueReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SELECTED_DMP_LEAGUE_LOADING: {
      let obj = { ...state, loading: true };
      return obj;
    }
    case GET_SELECTED_DMP_LEAGUE_SUCCESS: {
      let obj = { ...state, loading: false, data: action.response };
      return obj;
    }
    case GET_SELECTED_DMP_LEAGUE_ERROR: {
      let obj = { ...state, loading: false, data: action.response };
      return obj;
    }
    case GET_SELECTED_DMP_LEAGUE_ID: {
      let obj = { ...state, id: action.response };
      return obj;
    }
    case CLEAR_SELECTED_DMP_LEAGUE_ID: {
      let obj = { ...state, id: null };
      return obj;
    }
    case CLEAR_SELECTED_DMP_LEAGUE: {
      let obj = { ...state, data: {} };
      return obj;
    }
    default:
      return state;
  }
};

export default getSelectedDMPLeagueReducer;
